export default __webpack_public_path__ + "static/media/1252.be630d33.png";